import type { PathRouteProps } from 'react-router-dom';
import AccountPage from '~/pages/account/AccountPage';
import AdminPage from '~/pages/account/AdminPage';
import { DebugPage } from '~/pages/project/DebugPage';
import { AppSettingsPage } from '~/pages/settings/AppSettingsPage';
import { ProjectDateInputsTestPage } from '~/pages/testing/ProjectDateInputsTestPage';
import { TaxableValueInputsTestPage } from '~/pages/testing/TaxableValueInputsTestPage';
import { TestingIndexPage } from '~/pages/testing/TestingIndexPage';
import { ValuesTestingPage } from '~/pages/testing/values-testing/ValuesTestingPage';
import HomePage from '../pages/home/HomePage';
import ExistingDebtPage from '../pages/project/ExistingDebtPage';
import ProjectDetailsPage from '../pages/project/ProjectDetailsPage';
import ProjectReviewPage from '../pages/project/ProjectReviewPage';
import ProjectSetupPage from '../pages/project/ProjectSetupPage';
import ProposalDevelopmentPage from '../pages/project/ProposalDevelopmentPage';
import { PROJECT_ROUTES } from '../pages/project/projectRoutes';
import { ProjectRoute } from './ProjectRoute';
import { SuperAdminRoute } from './SuperAdminRoute';

/**
 * Note: ProjectWorkflowLayout has been removed and replaced with PageLayoutGrid.
 * Pages now handle their own layouts internally:
 * - ProjectSetupPage, ExistingDebtPage, ProposalDevelopmentPage use PageLayoutGrid
 * - ProjectDetailsPage, ProjectReviewPage use ProjectPageTemplate
 */

interface Props extends PathRouteProps {
  bodyPadding?: number[];
  bgColor?: string;
}

export const privateRoutes: Array<Props> = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: `/projects/:id/${PROJECT_ROUTES.OVERVIEW}`,
    element: (
      <ProjectRoute>
        <ProjectDetailsPage />
      </ProjectRoute>
    ),
  },
  {
    path: `/projects/:id/${PROJECT_ROUTES.SETUP}`,
    element: (
      <ProjectRoute>
        <ProjectSetupPage />
      </ProjectRoute>
    ),
  },
  {
    path: `/projects/:id/${PROJECT_ROUTES.EXISTING_DEBT}`,
    element: (
      <ProjectRoute>
        <ExistingDebtPage />
      </ProjectRoute>
    ),
  },
  {
    path: `/projects/:id/${PROJECT_ROUTES.PROPOSAL}`,
    element: (
      <ProjectRoute requiredStep="proposal">
        <ProposalDevelopmentPage />
      </ProjectRoute>
    ),
  },
  {
    path: `/projects/:id/${PROJECT_ROUTES.PROJECT_REVIEW}`,
    element: (
      <ProjectRoute requiredStep="review">
        <ProjectReviewPage />
      </ProjectRoute>
    ),
  },
  {
    path: '/projects/:id/debug/:configId',
    element: (
      <ProjectRoute requiredStep="proposal">
        <SuperAdminRoute>
          <DebugPage />
        </SuperAdminRoute>
      </ProjectRoute>
    ),
  },
  {
    path: '/account',
    element: <AccountPage />,
  },
  {
    path: '/settings',
    element: <AppSettingsPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/testing',
    element: <TestingIndexPage />,
  },
  {
    path: '/testing/project-date-inputs',
    element: <ProjectDateInputsTestPage />,
  },
  {
    path: '/testing/taxable-value-inputs',
    element: <TaxableValueInputsTestPage />,
  },
  {
    path: '/values-testing/:projectId/:configurationId',
    element: <ValuesTestingPage />,
  },
];
